/**
 * Loads Google Maps + Places script when key is configured.
 * Provides isLoaded and loadError via context for components that need Google APIs.
 * When no key: isLoaded stays false, fallback to OSS (Leaflet, Nominatim).
 */
import React, { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { hasGoogleMapsKey, getGoogleMapsApiKey } from './config';

const GoogleMapsContext = createContext({
  isLoaded: false,
  loadError: null,
});

export function useGoogleMaps() {
  return useContext(GoogleMapsContext);
}

function GoogleMapsProviderLoaded({ children }) {
  const apiKey = getGoogleMapsApiKey();
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'travel-planner-google-maps',
    googleMapsApiKey: apiKey,
    libraries: ['places'],
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}

export function GoogleMapsProvider({ children }) {
  const hasKey = hasGoogleMapsKey();

  if (!hasKey) {
    return (
      <GoogleMapsContext.Provider value={{ isLoaded: false, loadError: null }}>
        {children}
      </GoogleMapsContext.Provider>
    );
  }

  return <GoogleMapsProviderLoaded>{children}</GoogleMapsProviderLoaded>;
}
